import { style } from 'typestyle'
export const pl16 = style({ paddingLeft: '16px' })
